<template>
    <article class="file-item">
        <div class="icon-container clickable" @click="open()">
            <!--<svg-icon :symbol="iconSymbol.default" class="file-icon"></svg-icon>-->
            <svg class="file-icon icon">
                <use :xlink:href="'#' + basicType"></use>
            </svg>
        </div>

        <div class="header clickable" @click="open()">
            <h4 class="title">{{ material.title }}</h4>
            <div style="margin-top: auto;">
                <router-link v-if="material.signature_type === 'name' && isAuthenticated" :to="{ name: 'profiles', params: { 'id': material.owner.id } }" class="author" @click.native="$event.stopPropagation()">{{ material.signature }}</router-link>
                <p v-else-if="isAuthenticated" class="author">{{ material.signature }}</p>
                <p v-else class="author">FIZMIX portāla lietotājs</p>
                <p class="date">{{ material.created_at | moment("DD/MM/YYYY") }}</p>
            </div>
        </div>

        <footer>
            <slot name="footer">
                <div>
                    <div>
                        <a v-if="canLike" href="#" class="file-action file-action-like" @click.prevent="like()">
                            <svg-icon :symbol="likeIcon" :original-dims="true" class="icon-inline" :class="{ 'icon-like-active': material.is_liked }"></svg-icon><span class="count">{{ material.likes }}</span>
                        </a>
                        <span class="file-action file-action-like" v-else>
                            <svg-icon :symbol="likeIcon" :original-dims="true" class="icon-inline" :class="{ 'icon-like-active': material.is_liked }"></svg-icon><span class="count">{{ material.likes }}</span>
                        </span>
                        <span class="file-stat"><svg-icon :symbol="viewIcon" :original-dims="true" class="icon-inline"></svg-icon><span class="count">{{ material.views }}</span></span>
                        <span class="file-stat"><svg-icon :symbol="downloadIcon" :original-dims="true" class="icon-inline"></svg-icon><span class="count">{{ material.downloads }}</span></span>
                    </div>
                    <a v-if="canBookmark" href="#" class="file-action file-action-bookmark" @click.prevent="bookmark()"><svg-icon :symbol="bookmarkIcon" :original-dims="true" class="icon-inline" :class="{ 'icon-bookmark-active': material.has_bookmark }"></svg-icon></a>
                </div>
            </slot>
        </footer>
    </article>
</template>

<script>
    import SvgIcon from './SvgIcon.vue'
    import likeIcon from '../../icons/icon-like.svg-sprite'
    import bookmarkIcon from '../../icons/icon-bookmark.svg-sprite'
    import viewIcon from '../../icons/icon-view.svg-sprite'
    import downloadIcon from '../../icons/icon-download.svg-sprite'
    import materials from '../api/materials'
    import { mapGetters } from 'vuex'

    export default {

        props: {
            //TODO expand props
            material: Object
        },

        data() {
            return {
                likeIcon,
                bookmarkIcon,
                viewIcon,
                downloadIcon
            }
        },

        methods: {
            /**
             * Open current material page.
             */
            open() {
                this.$router.push({ name: 'material', params: { id: this.material.id } })
            },


            /**
             * Toggle current user like and trigger update event.
             * @returns {Promise<T>}
             */
            like() {
                const method = this.material.is_liked ? 'removeLike' : 'addLike';
                return materials[method](this.material.id)
                    .then(response => {
                        if (response.data.data.is_liked) {
                            this.$notify({title: 'Patīk atzīme pievienota!', type: 'success'});
                        } else {
                            this.$notify({title: 'Patīk atzīme noņemta!'});
                        }
                        this.$emit('update:material', response.data.data);
                        return response;
                    })
            },

            /**
             * Toggle current user bookmark and trigger update event.
             * @returns {Promise<T>}
             */
            bookmark: function () {
                const method = this.material.has_bookmark ? 'removeBookmark' : 'addBookmark';
                return materials[method](this.material.id)
                    .then(response => {
                        if (response.data.data.has_bookmark) {
                            this.$notify({ title: 'Grāmatzīme pievienota!', text: 'Grāmatzīmes vari atrast savā profila lapā.', type: 'success' });
                        } else {
                            this.$notify({ title: 'Grāmatzīme noņemta!' });
                        }

                        this.$emit('update:material', response.data.data);
                        return response;
                    });

            },
        },

        computed: {

            ...mapGetters(['isAuthenticated', 'user']),

            canLike: function () {
                return this.user && this.material.owner.id !== this.user.id;
            },

            canBookmark: function () {
                return this.user && this.material.owner.id !== this.user.id;
            },

            iconSymbol: function () {
                return require('../../icons/files/' + this.basicType + '.svg-files-sprite');
            },

            basicType: function () {
                return materials.basicType(this.material)
            }
        },

        components: { SvgIcon }
    }
</script>

<style lang="scss">
    @import "../../sass/settings";
    @import "../../sass/mixins";

    .file-item {
        background-color: white;
        border-radius: 8px;
        color: #404141;
        border: 1px solid #d7d8da;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-top: 0.9375rem * 2;//TODO implement Foundation gutters

        > .icon-container {
            background-color: #d3d0d0;
            padding: 1em;
            //flex: 0 0 119px;
            text-align: center;

            .file-icon {
                width: px-em(70px);
                height: px-em(70px);
            }
        }

        > .header {
            padding: 1em;

            .title {
                font-size: 13px;
                font-weight: 700;
                color: inherit;
                margin-bottom: 1em;
            }

            .author {
                font-weight: 400;
                font-size: 11px;
                color: inherit;
                margin-bottom: 1em;
            }

            .date {
                font-size: 11px;
                color: #999999;
                margin-bottom: 0;
            }
        }

        > footer > div {
            $footer-font-size: 11px;

            font-size: $footer-font-size;
            flex: 0 0 px-em(30px, $footer-font-size);
            background-color: #f6f6f6;
            border-top: 1px solid #d7d8da;
            padding: px-em(8px, $footer-font-size) px-em(16px, $footer-font-size);
            display: flex;
            justify-content: space-between;
            align-items: center;


            a {
                color: inherit;
                font-size: 1em;

                &:hover,
                &:active {
                    text-decoration: underline;
                }
            }

            svg.icon {
                fill: #999999;
                display: inline-block;
            }

            .file-action,
            .file-stat {
                white-space: nowrap;
                line-height: px-em(11px, $footer-font-size);
                margin-right: 1em;

                > * {
                    vertical-align: middle;
                }
            }

            .fil-action-like {
                .icon {
                    margin-right: px-em(8px, $footer-font-size);
                    margin-top: px-em(-3px, $footer-font-size);
                }
            }

            .file-action-bookmark {
                line-height: px-em(12px, $footer-font-size);
                height: px-em(12px, $footer-font-size);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/MaterialItem.vue